import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "react-i18next";
import { Button } from "@/components/button";
import { FormTextarea } from "@/components/form";
import { useEmrContext } from "@/hooks/emr-context";
import { useComposerStore } from "@/stores/composers";
import { useWorklistSocketStore } from "@/stores/worklist-socket";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
import { ComposerShell } from "./composer-shell";
/** Note composer: a free-text clinical note posted to the patient via WebSocket. */
export function NoteComposerBody(_ref) {
  var composer = _ref.composer;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useEmrContext = useEmrContext(),
    patientUid = _useEmrContext.patientUid;
  var close = useComposerStore(function (state) {
    return state.close;
  });
  var setContent = useComposerStore(function (state) {
    return state.setContent;
  });
  var send = useWorklistSocketStore(function (s) {
    return s.send;
  });
  var sendNote = function sendNote() {
    trackEvent(ANALYTICS_EVENTS.COMPOSER_SAVE, {
      composerId: composer.id
    });
    send("new_message", {
      patient_uid: patientUid,
      comment: composer.content,
      comment_uuid: crypto.randomUUID()
    });
    close(composer.id);
  };
  return /*#__PURE__*/React.createElement(ComposerShell, {
    composerId: composer.id,
    title: composer.title,
    subtitle: composer.subtitle,
    footer: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      variant: "ghost",
      "data-testid": "composer-cancel-".concat(composer.id),
      onClick: function onClick() {
        trackEvent(ANALYTICS_EVENTS.COMPOSER_CANCEL, {
          composerId: composer.id
        });
        close(composer.id);
      }
    }, t("cancel", {
      defaultValue: "Cancel"
    })), /*#__PURE__*/React.createElement(Button, {
      "data-testid": "composer-save-".concat(composer.id),
      disabled: !composer.content.trim(),
      onClick: sendNote
    }, t("send_note", {
      defaultValue: "Add note"
    })))
  }, /*#__PURE__*/React.createElement(FormTextarea, {
    label: t("note_text", {
      defaultValue: "Note"
    }),
    minRows: 8,
    placeholder: t("note_placeholder", {
      defaultValue: "Add a note…"
    }),
    value: composer.content,
    onChange: function onChange(event) {
      return setContent(composer.id, event.currentTarget.value);
    },
    onBlur: function onBlur() {
      return trackEvent(ANALYTICS_EVENTS.COMPOSER_CONTENT, {
        composerId: composer.id
      });
    },
    "data-testid": "composer-content-".concat(composer.id)
  }));
}